export default __webpack_public_path__ + "static/media/NowStreaming.2643477f.png";